import Layout from '@/layout/index.vue';
import { eEndPoint } from '@/interface/hot-game';
export const asyncRoutes = [
  {
    path: '/schedule',
    component: Layout,
    redirect: '/schedule/device_status',
    meta: {
      title: '调度管理',
      brand: ['limorecloud'],
      icon: 'tree',
      permission: {
        page: ['admin'],
      },
      breadcrumb: false,
      hidden: true,
      component: () => import('@/views/schedule/index.vue'),
    },
    children: [
      {
        path: 'device_status',
        name: 'status',
        component: () => import('@/views/schedule/device_status/index.vue'),
        meta: {
          title: '区域时态',
          hidden: true,
          brand: ['limorecloud'],
          // icon: 'dashboard',
        },
      },

      {
        path: 'device_import',
        name: 'device_import',
        component: () => import('@/views/schedule/device_import/index.vue'),
        meta: {
          title: '节点列表',
          hidden: true,
          brand: ['limorecloud'],
          // icon: 'table',
        },
      },
      {
        path: 'tactics',
        name: 'tactics',
        component: () => import('@/views/schedule/backup_tactics/index.vue'),
        meta: {
          title: '备机策略',
          hidden: true,
          brand: ['limorecloud'],
          // icon: 'table',
        },
      },
      {
        path: 'areamanage',
        name: 'areamanage',
        component: () => import('@/views/schedule/area_manage/index.vue'),
        meta: {
          title: '大区管理',
          hidden: true,
          brand: ['limorecloud'],
          // icon: 'table',
        },
      },
    ],
  },
  {
    path: '/coin',
    component: Layout,
    redirect: '/coin/recharge_record',
    name: 'coin',
    meta: {
      title: '订单管理',
      icon: 'example',
      permission: {
        page: ['admin'],
      },
      breadcrumb: false,
      component: () => import('@/views/coin_manage/index.vue'),
    },
    children: [
      {
        path: 'recharge_record',
        name: 'recharge',
        component: () => import('@/views/coin_manage/recharge_record/index.vue'),
        meta: {
          title: '充值记录',
          // icon: 'nested',
        },
      },
      {
        path: 'cloud_record_history',
        name: 'cloud_record_history',
        component: () => import('@/views/coin_manage/cloud_record_history/index.vue'),
        meta: {
          title: '云朵消费记录',
          // icon: 'nested',
        },
      },
      {
        path: 'consume_record',
        name: 'consume',
        component: () => import('@/views/coin_manage/consume_record/index.vue'),
        meta: {
          title: '消费记录',
          // icon: 'nested',
        },
      },
      {
        path: 'extension-withdrawal',
        name: 'extension-withdrawal',
        component: () => import('@/views/coin_manage/extension-withdrawal/index.vue'),
        meta: {
          title: '推广提现',
          // hidden: true,
          // brand: ['limorecloud'],
          // icon: 'nested',
        },
      },
      {
        path: 'price-admin',
        name: 'price-admin',
        component: () => import('@/views/coin_manage/price-admin/index.vue'),
        meta: {
          title: '价格管理',
          // icon: 'nested',
        },
      },
      {
        path: 'gift-admin',
        name: 'gift-admin',
        component: () => import('@/views/gift/index.vue'),
        meta: {
          title: '礼物管理',
          // icon: 'nested',
        },
      },
      {
        path: 'live-cash-out',
        name: 'live-cash-out',
        component: () => import('@/views/coin_manage/live_cash_out/index.vue'),
        meta: {
          title: '直播提现',
          // icon: 'nested',
        },
      },
    ],
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/device_data',
    name: 'statistics',
    meta: {
      title: '数据统计',
      icon: 'form',
      permission: {
        page: ['admin'],
      },
      breadcrumb: false,
      hidden: true,
      brand: ['limorecloud'],
      component: () => import('@/views/statistics/index.vue'),
    },
    children: [
      {
        path: 'device_data',
        name: 'device_data',
        component: () => import('@/views/statistics/device_data/index.vue'),
        meta: {
          title: '设备使用',
          // icon: 'table',
        },
      },
      {
        path: 'realtime_data',
        name: 'realtime_data',
        component: () => import('@/views/statistics/realtime_data/index.vue'),
        meta: {
          title: '实时数据',
          // icon: 'table',
        },
      },
      /* {
        path: 'cancel-detial',
        name: 'canceldetial',
        component: () => import('@/views/statistics/cancel-detial/index.vue'),
        meta: {
          title: '撤单明细',
          // icon: 'table',
        },
      }, */
      {
        path: 'newadd-active',
        name: 'newaddactive',
        component: () => import('@/views/statistics/newadd-active/index.vue'),
        meta: {
          title: '新增/活跃',
          // icon: 'table',
        },
      },
      {
        path: 'recharge-consum',
        name: 'recharge-consum',
        component: () => import('@/views/statistics/recharge-consum/index.vue'),
        meta: {
          title: '充值/消费',
          // icon: 'table',
        },
      },
      {
        path: 'node-analysis',
        name: 'node-analysis',
        component: () => import('@/views/statistics/node-analysis/index.vue'),
        meta: {
          title: '节点分析',
          // icon: 'table',
        },
        children: [
          {
            path: 'node-summary',
            name: 'node-summary',
            component: () => import('@/views/statistics/node-analysis/node-summary.vue'),
            meta: {
              title: '节点概况',
            },
          },
          {
            path: 'node-device',
            name: 'node-device',
            component: () => import('@/views/statistics/node-analysis/node-device.vue'),
            meta: {
              title: '节点设备',
            },
          },
        ],
      },
      {
        path: 'device-time-status',
        name: 'device-time-status',
        component: () => import('@/views/statistics/device-time-status/index.vue'),
        meta: {
          title: '设备状态',
          // icon: 'table',
        },
      },
      {
        path: 'delay-analysis',
        name: 'delay-analysis',
        component: () => import('@/views/statistics/delay-analysis/index.vue'),
        meta: {
          title: '延迟分析',
        },
      },
    ],
  },
  {
    path: '/users',
    component: Layout,
    redirect: '/users/list',
    name: 'users',
    meta: {
      title: '用户管理',
      icon: 'user',
      permission: {
        page: ['admin'],
      },
      breadcrumb: false,
      component: () => import('@/views/user_manage/index.vue'),
    },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/user_manage/user_list/index.vue'),
        meta: {
          title: '用户列表',
        },
      },
      {
        path: 'distribute',
        name: 'distribute',
        component: () => import('@/views/user_manage/user_list/area_distribute.vue'),
        meta: {
          title: '地域分布',
          hidden: true,
          brand: ['limorecloud'],
        },
      },
    ],
  },
  {
    path: '/marketing',
    component: Layout,
    redirect: '/marketing/code',
    meta: {
      title: '营销管理',
      icon: 'zip',
      breadcrumb: false,
      alwaysShow: true,
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: 'virtual-keyboard',
        component: () => import('@/views/marketing/virtual-keyboard/index.vue'),
        name: 'virtual-keyboard',
        meta: {
          title: '虚拟键盘',
          // icon: 'zip',
        },
      },
      {
        path: 'promote-code',
        component: () => import('@/views/marketing/promote-code/index.vue'),
        name: 'permission',
        meta: {
          title: '推广码',
          // icon: 'zip',
        },
      },
      {
        path: 'old-promote',
        component: () => import('@/views/marketing/promote-code/components/old-promote.vue'),
        name: 'oldpermission',
        meta: {
          title: '(旧)推广码',
          // icon: 'zip',
        },
      },
      {
        path: 'code',
        component: () => import('@/views/marketing/exchange-code/index.vue'),
        name: 'code',
        meta: {
          title: '兑换码',
          // icon: 'zip',
        },
      },

      // {
      //   path: 'adsense-notice',
      //   component: () => import('@/views/marketing/adsense-notice/index.vue'),
      //   name: 'adsense-notice',
      //   meta: {
      //     title: '广告位/公告',
      //     // icon: 'zip',
      //   },
      // },
      {
        path: 'game-manage',
        component: () => import('@/views/marketing/game-manager/index.vue'),
        name: 'game-manager',
        meta: {
          title: '游戏管理',
        },
      },
      {
        path: 'game-discussion',
        component: () => import('@/views/marketing/game-discussion-manange/index.vue'),
        name: 'game-discussion',
        meta: {
          title: '游戏讨论',
          // hidden: true,
          // brand: ['limorecloud'],
        },
      },
      {
        path: 'channel-extension',
        component: () => import('@/views/marketing/channel-extension/index.vue'),
        name: 'channel-extension',
        meta: {
          title: '渠道推广',
        },
      },
      {
        path: 'message-push',
        component: () => import('@/views/marketing/message-push/index.vue'),
        name: 'message-push',
        meta: {
          title: '消息推送',
        },
      },
      {
        path: 'cloud-update-promotion',
        component: () => import('@/views/marketing/cloud-update-promotion/index.vue'),
        name: 'permission',
        meta: {
          title: '云更新推广',
          // icon: 'zip',
        },
      },
      {
        path: 'top-up-active',
        component: () => import('@/views/marketing/top-up-active/index.vue'),
        name: 'permission',
        meta: {
          title: '充值活动',
        },
      },
      {
        path: '/marketing-campaign',
        component: () => import('@/views/marketing/marketing-campaign/index.vue'),
        name: 'permission',
        meta: {
          title: '签到/福利任务',
        },
      },
      {
        path: '/cloud-computer-tip',
        component: () => import('@/views/marketing/cloud-computer-tip/index.vue'),
        name: 'permission',
        meta: {
          title: '云电脑内提示',
        },
      },
      {
        path: 'room-manage',
        component: () => import('@/views/marketing/room-manage/index.vue'),
        name: 'room-manage',
        meta: {
          title: '房间管理',
        },
      },
      // {
      //   path: 'evaluate-gift',
      //   component: () => import('@/views/marketing/evaluate-gift/index.vue'),
      //   name: 'evaluate-gift',
      //   meta: {
      //     title: '流量变现',
      //   },
      // },

      {
        path: 'room-list',
        component: () => import('@/views/marketing/room-manage/room-list/index.vue'),
        name: 'room-list',
        meta: {
          title: '游戏房间详情',
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/android',
    component: Layout,
    redirect: '/marketing/code',
    meta: {
      title: '安卓管理',
      icon: 'android',
      breadcrumb: false,
      alwaysShow: true,
      // hidden: true,
      brand: ['limorecloud'],
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: 'adsense-notice',
        component: () => import('@/views/android/adsense-notice/index.vue'),
        name: 'adsense-notice-android',
        meta: {
          title: '广告位/公告',
          type: eEndPoint.ADNROID,
        },
      },
      {
        path: 'hot-game',
        component: () => import('@/views/android/hot-game/index.vue'),
        name: 'hot-game-android',
        meta: {
          title: '游戏入口管理',
          type: eEndPoint.ADNROID,
        },
      },
      {
        path: 'version-config',
        component: () => import('@/views/android/version/index.vue'),
        name: 'version-config',
        meta: {
          title: '版本管理',
          type: eEndPoint.ADNROID,
        },
      },
      {
        path: 'hot-game-type',
        component: () => import('@/views/android/hot-game-type/index.vue'),
        name: 'hot-game-type-android',
        meta: {
          title: '热门游戏类别',
          type: eEndPoint.ADNROID,
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/ios',
    component: Layout,
    redirect: '/marketing/code',
    meta: {
      title: 'IOS管理',
      icon: 'android',
      breadcrumb: false,
      alwaysShow: true,
      // hidden: true,
      // brand: ['limorecloud'],
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: 'adsense-notice',
        component: () => import('@/views/ios/adsense-notice/index.vue'),
        name: 'adsense-notice-ios',
        meta: {
          title: '广告位/公告',
          // type: eEndPoint.IOS,
        },
      },
      {
        path: 'hot-game',
        component: () => import('@/views/android/hot-game/index.vue'),
        name: 'hot-game',
        meta: {
          title: '热门游戏',
          type: eEndPoint.IOS,
        },
      },
      {
        path: 'hot-game-type',
        component: () => import('@/views/android/hot-game-type/index.vue'),
        name: 'hot-game-type',
        meta: {
          title: '热门游戏类别',
          type: eEndPoint.IOS,
          hidden: true,
        },
      },
      {
        path: 'version-config',
        component: () => import('@/views/ios/version/index.vue'),
        name: 'version-config',
        meta: {
          title: '版本管理',
          type: eEndPoint.IOS,
        },
      },
    ],
  },
  {
    path: '/service',
    component: Layout,
    redirect: '/service/user-feedback',
    name: 'service',
    meta: {
      title: '客服工具',
      icon: 'dashboard',
      breadcrumb: false,
      component: () => import('@/views/service-tool/index.vue'),
      permission: {
        page: ['admin', 'super_customer', 'customer'],
        button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
      },
    },
    children: [
      {
        path: 'user-feedback',
        name: 'userfeedback',
        component: () => import('@/views/service-tool/user-feedback/index.vue'),
        meta: {
          title: '用户反馈',
          permission: {
            page: ['admin', 'super_customer', 'customer'],
            button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
          },
        },
      },
      {
        path: 'device-inspection',
        name: 'deviceinspection',
        component: () => import('@/views/service-tool/device-inspection/index.vue'),
        meta: {
          title: '设备巡检',
          hidden: true,
          brand: ['limorecloud'],
          permission: {
            page: ['admin', 'super_customer'],
            button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
          },
        },
      },
      {
        path: 'recharge-query',
        name: 'rechargequery',
        component: () => import('@/views/service-tool/recharge-query/index.vue'),
        meta: {
          title: '充值查询',
          permission: {
            page: ['admin', 'super_customer', 'customer'],
            button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
          },
        },
      },
      {
        path: 'consumption-query',
        name: 'consumptionquery',
        component: () => import('@/views/service-tool/consumption-query/index.vue'),
        meta: {
          title: '消费查询',
          permission: {
            page: ['admin', 'super_customer', 'customer'],
            button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
          },
        },
      },
      {
        path: 'user-query',
        name: 'userquery',
        component: () => import('@/views/service-tool/user-query/index.vue'),
        meta: {
          title: '用户查询',
          permission: {
            page: ['admin', 'super_customer', 'customer'],
            button: { del: ['admin', 'super_customer'], edit: ['admin', 'super_customer'], add: ['admin', 'super_customer'] },
          },
        },
      },
    ],
  },
  {
    path: '/web',
    component: Layout,
    redirect: '/marketing/code',
    meta: {
      title: 'WEB',
      icon: 'tree',
      breadcrumb: false,
      alwaysShow: true,
      // hidden: true,
      brand: ['limorecloud'],
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: 'adsense-notice',
        component: () => import('@/views/android/adsense-notice/index.vue'),
        name: 'adsense-notice-web',
        meta: {
          title: 'banner位',
          type: eEndPoint.WEB,
        },
      },
      {
        path: 'hot-game',
        component: () => import('@/views/android/hot-game/index.vue'),
        name: 'hot-game-web',
        meta: {
          title: '热门游戏',
          type: eEndPoint.WEB,
        },
      },
      {
        path: 'hot-game-type',
        component: () => import('@/views/android/hot-game-type/index.vue'),
        name: 'hot-game-type-web',
        meta: {
          title: '热门游戏类别',
          type: eEndPoint.WEB,
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/pc',
    component: Layout,
    redirect: '/marketing/code',
    meta: {
      title: 'PC',
      icon: 'nested',
      breadcrumb: false,
      alwaysShow: true,
      brand: ['limorecloud'],
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: 'adsense-notice',
        component: () => import('@/views/marketing/adsense-notice/index.vue'),
        name: 'adsense-notice',
        meta: {
          title: '广告位/公告',
          // icon: 'zip',
        },
      },
      {
        path: 'hot-game',
        component: () => import('@/views/android/hot-game/index.vue'),
        name: 'hot-game-pc',
        meta: {
          title: '热门游戏',
          type: eEndPoint.PC,
        },
      },
      {
        path: 'hot-game-type',
        component: () => import('@/views/android/hot-game-type/index.vue'),
        name: 'hot-game-type-pc',
        meta: {
          title: '热门游戏类别',
          type: eEndPoint.PC,
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/系统设置',
    component: Layout,
    redirect: '/system',
    meta: {
      title: '系统设置',
      icon: 'user',
      breadcrumb: false,
      alwaysShow: true,
      permission: {
        page: ['admin'],
      },
    },
    children: [
      {
        path: '/system/real-certification',
        component: () => import('@/views/system/real-certification/index.vue'),
        name: 'real-certificatio',
        meta: {
          title: '实名认证',
        },
      },
      {
        path: '/system/verify-code-set',
        component: () => import('@/views/system/verify-code-set/index.vue'),
        name: 'verify-code-set',
        meta: {
          title: '验证设置',
        },
      },
    ],
  },
  // {
  //   path: '/permission',
  //   name: 'permission',
  //   component: Layout,
  //   meta: {
  //     title: '权限管理',
  //     permission: {
  //       page: ['admin'],
  //       button: { del: ['admin'], edit: ['admin'], add: ['admin'] },
  //     },
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'permission-list',
  //       component: () => import('@/views/permission/index.vue'),
  //       meta: {
  //         title: '权限列表',
  //         permission: {
  //           page: ['admin'],
  //           button: { del: ['admin'], edit: ['admin'], add: ['admin'] },
  //         },
  //       },
  //     },
  //   ],
  // },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: {
      title: '丢失页面',
      hidden: true,
    },
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true },
  },
];
